export default "data:image/gif;base64,R0lGODlhCgAKAKEBABAQEDw8PG9vbzw8PCH5BAEKAAMALAAAAAAKAAoAAAIenD9ywS1hAphAADgktVhXHgmWdUUf2U1kmTUuAhsFADs="